import { Query } from '@apollo/client/react/components';
import GroupOptionsRequestToJoinCheckbox from './GroupOptionsRequestToJoinCheckbox';
import React from 'react';
import GROUP_MEMBERSHIP_REQUESTS_COUNT_QUERY from 'groupMembershipRequests/containers/queries/GroupMembershipRequestsCountQuery.gql';
import { isNil } from 'lodash';
import idx from 'idx';
import { mountModal } from 'lib/modal';
import ConfirmDialog from 'components/ConfirmDialog';

const renderDisableRequestToJoinModal = (count: number, onConfirm: () => void) => {
  return (
    <ConfirmDialog
      title="Approve pending requests?"
      subtext={`There are currently ${count} pending requests to join this class. By unchecking this box, do you want to approve their requests?`}
      cancelButtonText="Cancel"
      actionButtonText={`Approve ${count} pending requests`}
      onConfirm={onConfirm}
    />
  );
};

const RequestToJoinContainer = ({
  requestToJoinFromBackend,
  requestToJoinEnabledRecommendation,
  requestToJoinFromFrontend,
  groupUuid,
  setRequestToJoinEnabled,
  disabled,
}: {
  requestToJoinFromBackend?: boolean | null;
  requestToJoinEnabledRecommendation: string;
  requestToJoinFromFrontend?: boolean | null;
  groupUuid: string | null | undefined;
  setRequestToJoinEnabled: (enabled: boolean) => void;
  disabled: boolean;
}) => {
  const requestToJoinEnabled: boolean = (
    isNil(requestToJoinFromFrontend) ? requestToJoinFromBackend : requestToJoinFromFrontend
  ) as boolean;

  return (
    <Query
      query={GROUP_MEMBERSHIP_REQUESTS_COUNT_QUERY}
      variables={{ groupUuid }}
      fetchPolicy="network-only"
      skip={!requestToJoinEnabled}
    >
      {/* @ts-expect-error ts-migrate(2322) FIXME .... Remove this comment to see the full error message */}
      {({ data }) => {
        const requestCount =
          (data && idx(data, (_) => _.classes[0].groupMembershipRequestsCount)) || 0;
        return (
          <GroupOptionsRequestToJoinCheckbox
            disabled={disabled}
            checked={requestToJoinEnabled}
            requestToJoinEnabledRecommendation={requestToJoinEnabledRecommendation}
            onChange={(e, requestToJoinMutation) => {
              // @ts-expect-error ts-migrate(2339) FIXME: Property 'checked' does not exist on type 'EventTa... Remove this comment to see the full error message
              const enabled = e.target.checked;
              const toggleRequestToJoin = () => {
                requestToJoinMutation({ variables: { input: { groupUuid, enabled } } });
                setRequestToJoinEnabled(enabled);
              };

              if (requestToJoinEnabled && requestCount > 0) {
                mountModal(
                  renderDisableRequestToJoinModal(requestCount, toggleRequestToJoin),
                  this
                );
              } else {
                toggleRequestToJoin();
              }
            }}
          />
        );
      }}
    </Query>
  );
};

export default RequestToJoinContainer;
